// 输入框可选类型
const inputFieldType = {
    text: 1,
    number: 2,
    radio: 3,
    checkbox: 4,
    numberRange: 5,
    datetimeRange: 6,
    addUpNumberRange: 7,
};
const checked = '1'; // 选中
// const uncheck = '0' // 不选中
// 判断是否为空
const isBlank = (val) => {
    return val === undefined || val === null || val === '';
};
/**
 * 解析运营后台工具的奖品数据结构，奖品数据为一个二维数组
 * @author jingyu_zhou
 */
class PrizeDecoder {
    constructor(attrs = [], fieldListKey = 'msPrizeAttributeFieldValueRespDTOS') {
        this.fieldListKey = fieldListKey;
        if (!isBlank(attrs) && attrs.constructor.name === 'Array') {
            this.setMaps(attrs);
        }
    }
    /**
     * 通过一维数组解析奖品数据
     * @param fields
     * @param ptCode
     */
    decodeFields(fields = [], ptCode) {
        const attrs = [];
        const attrsObject = {};
        fields.forEach(field => {
            const { prizeTypeCode, prizeAttributeCode, attributeName: ptName, prizeAttributeName: ptName2, inputFieldType } = field;
            if (!attrsObject[prizeAttributeCode]) {
                attrsObject[prizeAttributeCode] = {
                    prizeTypeCode: ptCode || prizeTypeCode,
                    prizeAttributeCode,
                    prizeAttributeName: ptName || ptName2,
                    inputFieldType,
                };
                attrsObject[prizeAttributeCode][this.fieldListKey] = [];
            }
            attrsObject[prizeAttributeCode][this.fieldListKey].push(field);
        });
        Object.keys(attrsObject).forEach(attrCode => attrs.push(attrsObject[attrCode]));
        this.setMaps(attrs);
    }
    /**
     * 设置各种参数
     * @param attrs
     */
    setMaps(attrs) {
        this.attrs = attrs;
        this.attrsMap = new Map(); // 保存key为prizeAttributeCode的键、字段列表对
        this.fieldsMap = new Map(); // 保存key为fieldKey的键、字段详情对
        this.valuesMap = new Map(); // 保存key为prizeAttributeCode的键、结果值对
        this.keysMap = new Map(); // 保存key为prizeAttributeCode的键、结果key对
        this.attrs.forEach(attr => {
            const { prizeAttributeCode, inputFieldType: inputType } = attr;
            const fields = attr[this.fieldListKey];
            this.attrsMap.set(prizeAttributeCode, attr);
            if (!isBlank(fields)) {
                fields.forEach(field => {
                    const { fieldKey } = field;
                    field.inputFieldType = inputType;
                    this.fieldsMap.set(fieldKey, field);
                });
                let values = null;
                let keys = null;
                switch (inputType) {
                    case inputFieldType.radio:
                        fields.forEach(item => {
                            if (item.fieldValue === checked) {
                                values = item.fieldName;
                                keys = item.fieldKey;
                            }
                        });
                        break;
                    case inputFieldType.checkbox:
                        values = [];
                        keys = [];
                        fields.forEach(item => {
                            if (item.fieldValue === checked) {
                                values.push(item.fieldName);
                                keys.push(item.fieldKey);
                            }
                        });
                        break;
                    case inputFieldType.numberRange:
                    case inputFieldType.datetimeRange:
                        values = [];
                        keys = [];
                        fields.forEach(item => {
                            values.push(item.fieldValue);
                            keys.push(item.fieldKey);
                        });
                        break;
                    case inputFieldType.addUpNumberRange:
                        values = [];
                        keys = [];
                        fields.forEach((item, index) => {
                            const isChecked = item.fieldValue === checked;
                            if (index === 0 || index === 1) {
                                values.push(item.fieldValue);
                                keys.push(item.fieldKey);
                            }
                            else if (index === 2) {
                                values.push(isChecked); // 第3个值为是否累计，累计为true，不累计为false
                                isChecked && keys.push(item.fieldKey); // 第3个值为是否累计的key
                            }
                            else if (index === 3 && isChecked) {
                                values[2] = !isChecked;
                                keys[2] = item.fieldKey;
                            }
                        });
                        break;
                    case inputFieldType.text:
                    case inputFieldType.number:
                    default: // 无输入类型时取第一个值
                        if (fields[0]) {
                            values = fields[0].fieldValue;
                            keys = fields[0].fieldKey;
                        }
                        break;
                }
                this.valuesMap.set(prizeAttributeCode, values);
                this.keysMap.set(prizeAttributeCode, keys);
            }
        });
    }
    /**
     * 通过属性code获得属性name
     * @param code 属性code
     * @returns {null|*}
     */
    getAttrNameByAttrCode(code) {
        const attr = this.attrsMap.get(code);
        return isBlank(attr) ? null : attr.prizeAttributeName;
    }
    /**
     * 通过字段key获得字段name
     * @param key 字段key
     * @returns {null|*}
     */
    getFieldNameByFieldKey(key) {
        const field = this.fieldsMap.get(key);
        return isBlank(field) ? null : field.fieldName;
    }
    /**
     * 通过属性code获得属性值
     * @param code 属性code
     * @returns {any}
     */
    getAttrValueByAttrCode(code) {
        return this.valuesMap.get(code);
    }
    /**
     * 通过属性code获得属性值对应的key
     * @param code
     * @returns {any}
     */
    getValueKeyByAttrCode(code) {
        return this.keysMap.get(code);
    }
    /**
     * 获取奖品类型code
     * @returns {null}
     */
    getPrizeTypeCode() {
        return this.attrs[0] ? this.attrs[0].prizeTypeCode : null;
    }
    /**
     * 可选类型的某个key对应的选项是否被选中
     * @param key
     * @returns {boolean}
     */
    fieldIsChecked(key) {
        const field = this.fieldsMap.get(key);
        if (isBlank(field))
            return false; // 无对应字段
        const { inputFieldType: inputType, fieldValue } = field;
        if (inputType !== inputFieldType.radio && inputType !== inputFieldType.checkbox)
            return false; // 字段类型不为radio或checkbox
        return fieldValue === checked;
    }
}
export default PrizeDecoder;
